import React, { Fragment, useEffect } from 'react';
// nodejs library that concatenates classes
import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
//import Clearfix from '../../components/UI/Clearfix/Clearfix';
// Sections for this page
import IndexIdentidad from '../../components/IndexPage/IndexIdentidad/IndexIdentidad';
import IndexServicios from '../../components/IndexPage/IndexServicios/IndexServicios';
import IndexCursos from '../../components/IndexPage/IndexCursos/IndexCursos';

import indexPageStyle from '../../assets/jss/coscef/views/indexPageStyle';

const useStyles = makeStyles(indexPageStyle);

const IndexPage = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();

  return (
    <Fragment>
      <div
        className={classNames(classes.main, classes.mainRaised)}
        id='main-panel'
      >
        <IndexIdentidad />
        <IndexServicios {...props} />
        <IndexCursos {...props} />
      </div>
      <div className={classes.section}></div>
    </Fragment>
  );
};

export default IndexPage;
